module.exports = __webpack_public_path__ + "static/media/groupPeople.d7a00b7f.svg";